export default ({ Vue }) => {
  // eslint-disable-next-line no-extend-native
  String.prototype.interpolate = function (params) {
    const names = Object.keys(params)
    const vals = Object.values(params)
    // eslint-disable-next-line no-new-func
    return new Function(...names, `return \`${this}\`;`)(...vals)
  }

  // eslint-disable-next-line no-extend-native
  String.prototype.ucfirst = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
  }

  // eslint-disable-next-line no-extend-native
  String.prototype.nl2br = function () {
    return this.replace(/(?:\r\n|\r|\n)/g, '<br>')
  }

  // eslint-disable-next-line no-extend-native
  String.prototype.englishOnly = function (value) {
    if (!value) return ''
    const regex = /[^a-zA-Z0-9,;\s]/g
    return value.replace(regex, '')
  }

  // eslint-disable-next-line no-extend-native
  Vue.directive('english-only', {
    bind (el) {
      el.addEventListener('input', function (event) {
        const input = event.target.value
        // Regular expression to allow only English letters (both uppercase and lowercase) and spaces
        const regex = /^[a-zA-Z0-9,;\s]*$/
        if (!regex.test(input)) {
          event.target.value = input.replace(/[^a-zA-Z0-9,;\s]/g, '')
          el.dispatchEvent(new Event('input'))
        }
      })
    }
  })
}
